import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'living_wage_local_currency'

export const dataPointDefinition = {
  retracedId: 'living_wage_local_currency',
  name: 'What is the living wage in local currency?',
  meta: {},
  fieldTypeId: 'NUMBER_DYNAMIC_CURRENCY_WITH_YEAR',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      unit: {
        type: 'string',
      },
      value: {
        type: 'number',
      },
      year: {
        type: 'number',
        minimum: 1000,
        maximum: 9999,
      },
    },
    required: ['value', 'year', 'unit'],
  },
  externalIds: [
    {
      id: 'Green Button: 2.3.2 Wage gap analysis',
    },
  ],
  sortingId: 9806,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
